import moment from 'moment'

export default class RecruiterInvitationDetail {
  constructor(object) {
    this.invitationId = object.invitation_id
    this.applicantId = object.applicant_id || null
    this.invitationName = object.invitation_name
    this.cooperatedAt = typeof object.cooperated_at === 'undefined' ? null : moment.unix(object.cooperated_at)
    this.appliedAt = typeof object.applied_at === 'undefined' ? null : moment.unix(object.applied_at)
    this.applicantName = object.applicant_name || null
    this.position = object.position
    this.offerTitle = object.offer_title || null
    this.status = object.status || null
  }
}
